// Pure grouping/scoping logic for the Add-Crates sheet, extracted so it
// can be unit-tested without pulling in React Native.
//
// A physical crate can carry customers from SEVERAL localities (one crate
// routinely bundles a few neighbouring localities). Each customer belongs
// to their OWN locality — tp.cx_locality, stamped by the backend = the
// same locality web's "Locality" view groups by. We scope a crate to one
// locality at a time: only the customers whose own locality matches.
//
// STRICT match (no null-safe keep): a customer whose cx_locality is
// missing/blank or != the locality is excluded. This is FAIL-SAFE — if the
// backend ever stops sending cx_locality the sheet shows fewer customers
// (loud + harmless) instead of silently assigning foreign-locality
// customers to the wrong DB.
export const tpsInLocality = (crate, locality) => {
  const L = String(locality ?? "");
  if (!L) return [];
  return (Array.isArray(crate?.tp_list) ? crate.tp_list : []).filter(
    (tp) => tp?.user_id != null && String(tp?.cx_locality ?? "") === L,
  );
};

// Group crates by the localities the DB serves. A crate is listed under a
// locality ONLY if it has >=1 customer whose own locality matches, and it
// carries that locality-scoped customer list. A shared crate therefore
// appears under EACH locality it serves, each time showing only that
// locality's customers — exactly like web (assign a locality -> only that
// locality's own-address customers). Returns [{ route, crates: [{ crate,
// cxs }] }].
export const groupForDb = (crates, db) => {
  const routes = Array.isArray(db?.routes) ? db.routes : [];
  if (routes.length === 0) return [];
  const all = Array.isArray(crates) ? crates : [];
  return routes.map((r) => ({
    route: r,
    crates: all
      .map((crate) => ({ crate, cxs: tpsInLocality(crate, r.route_name) }))
      .filter((entry) => entry.cxs.length > 0),
  }));
};
